export default __webpack_public_path__ + "static/media/hunterwake.f25bc16b.mp3";